import React, { useState, useEffect } from "react";
import "./App.css";
import { withRouter } from "react-router-dom";

import { Fragment } from "react";
import "react-multiple-select-dropdown-lite/dist/index.css";
import { ToastContainer } from "react-toastify";

import { isNullOrEmpty } from "./config/ENV";
import firebase from "firebase/compat/app";
import LoginRoutes from "./Routes/LoginRoutes";
import ClientRoutes from "./Routes/ClientRoutes";
import {FaAngleUp } from "react-icons/fa";
const App = () => {
  const scrollToTop = () => {
    const element = document.getElementById('scrollToTop')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
  const url = window.location.href;
  const query = new URLSearchParams(window.location.search);

  const handleLogout = () => {

    firebase
      .auth()
      .signOut()
      .then(function () {
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("account");
        window.localStorage.clear();
      })
      .catch(function () {});
  };

  if (!isNullOrEmpty(query.get("p"))) {
    const page = query.get("p");
    window.localStorage.setItem("page", page);
  }
  if (!isNullOrEmpty(query.get("id"))) {
    //window.localStorage.clear();
    const hmsId = query.get("id");
    window.sessionStorage.setItem("hmsId", hmsId);
  }

  if (!isNullOrEmpty(query.get("empcode"))) {
    window.localStorage.clear();
    handleLogout();
    const page = query.get("p");
    window.localStorage.setItem("page", page);
    const empcode = query.get("empcode");
    window.sessionStorage.setItem("empcode", empcode);
  }

  return (
    
    <Fragment>
       <div className="t-top-to-btm">
            {" "}
            {showTopBtn && (
                <FaAngleUp
                    className="t-icon-position t-icon-style"
                    onClick={goToTop}
                />
            )}{" "}
        </div>

      {(() => {
        if (isNullOrEmpty(window.localStorage.getItem("page"))) {
          return <LoginRoutes />;
        } else if (window.localStorage.getItem("page") == "hms") {
          if (isNullOrEmpty(window.sessionStorage.getItem("hmsId"))) {
            return <LoginRoutes />;
          } else {
            return <ClientRoutes />;
          }
        } else if (window.localStorage.getItem("page") == "membersignup") {
          if (!isNullOrEmpty(window.sessionStorage.getItem("empcode"))) {
            return <LoginRoutes />;
          } else {
            return <LoginRoutes />;
          }
        } else {
          return <LoginRoutes />;
        }
      })()}

      <ToastContainer
       className="t-toast-width Toastify__toast-container--top-center "
       rtl={true}
       autoClose={6000}
       draggable={true}
       closeButton={true}
       pauseOnHover={true}
        // rtl={true}
        // autoClose={1000}
        // closeButton={false}
        // pauseOnHover={true}
      />
    </Fragment>
  );
};

export default withRouter(App);
